import * as React from 'react';
import * as Classes from '../common/classes';
import { FieldRenderProps, useFormState } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import {
  defaultMultiSelectGetLabel,
  defaultMultiSelectRenderItem,
  MultiSelectItem,
} from '../multiselect/MultiSelectSearch';
import classNames from 'classnames';
import { ApiMultiSelectSearch } from '../multiselect/ApiMultiSelectSearch';
import { Text } from '../typography/Text';
import { isMobile } from '../common/utils';
import { FilterInputButton } from '../button/FilterInputButton';
import { useEffect, useRef } from 'react';
import { refreshItems } from '../autocomplete/utils';
import { get } from 'lodash-es';
import { DATA_FILTER_INPUT } from '../common/data';

export type FilterApiMultiSelectProps = VFFilterFieldProps<
  React.ComponentProps<typeof ApiMultiSelectSearch> & FilterFieldProps
>;
export const FilterApiMultiSelect = React.forwardRef<
  HTMLInputElement,
  FilterApiMultiSelectProps
>(
  (
    {
      name,
      getLabel = defaultMultiSelectGetLabel,
      renderItem = defaultMultiSelectRenderItem,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      filterType,
      searchItems,
      getItemsByIds,
      extendedFilter,
      size = 14,
      ...other
    },
    ref
  ) => {
    const { values } = useFormState();
    const [editedValues, setEditedValues] = React.useState<any[]>();

    const selectedItems: undefined | any[] = get(
      values,
      getFilterFieldFormValuePath(name, filterType)
    );
    const currentValuesRef = useRef<MultiSelectItem[]>();
    useEffect(() => {
      if (getItemsByIds) {
        if (currentValuesRef.current !== selectedItems) {
          // @ts-ignore
          refreshItems(
            // @ts-ignore
            setEditedValues,
            selectedItems ? selectedItems.map((i) => i.id) : [],
            getItemsByIds
          );
          currentValuesRef.current = selectedItems;
        }
      }
    }, [selectedItems]);

    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<any[]>) => {
            let titleArr: string[] = [];
            const valueList: any[] = []; // pole obsahujici vybrane editovane polozky (pokud existuji) a puvodni polozky (pokud neexistuji editovane)
            // let tooltipArr: any[] = [];
            value &&
              value.forEach((v) => {
                let editItem;
                if (editedValues) {
                  editItem = editedValues.find((item) => item.id === v.id);
                }

                titleArr.push(getLabel(editItem ?? v));
                valueList.push(editItem ?? v);
                // tooltipArr.push(<ListItem>{renderItem(v)}</ListItem>);
              });

            let info: React.ReactNode = '-';
            if (!value || valueList.length === 0) {
              info = (
                <Text intent={'inactive'} italic>
                  Nevybráno
                </Text>
              );
            } else if (valueList.length === 1) {
              info = titleArr[0];
            } else {
              info = `${titleArr[0]} +${valueList.length - 1}`;
            }

            return (
              <FilterInputButton
                {...DATA_FILTER_INPUT(name)}
                tooltip={
                  titleArr.length > 0 ? titleArr.join(', ') : '-nevybráno-'
                  //   tooltipArr.length > 0 ? (
                  //     <List
                  //       compact
                  //       noTopBottomRows
                  //       style={{ maxHeight: 300, overflowY: 'auto' }}
                  //     >
                  //       {tooltipArr}
                  //     </List>
                  //   ) : (
                  //     '-nevybráno-'
                  //   )
                }
                className={Classes.FILTER_MULTI_SELECT}
                disabled={disabled || meta.submitting}
                cssStyle={{
                  width: `${size}em`,
                }}
                popupProps={{
                  mode: 'edit',
                  closeOnInnerClick: false,
                  arrow: true,
                  focusContentOnOpen: true,
                  position: isMobile
                    ? ['bottom left', 'top left', 'bottom center', 'top center']
                    : undefined,
                }}
                menu={(closePopup) => (
                  <ApiMultiSelectSearch
                    closePopup={closePopup}
                    className={classNames(
                      inputClassName,
                      Classes.FILTER_MULTI_LIST
                    )}
                    value={valueList}
                    // @ts-ignore
                    ref={ref}
                    {...nother}
                    {...other}
                    renderItem={renderItem}
                    onChange={(ids) => {
                      currentValuesRef.current = ids;
                      onChange({ target: { name, value: ids } });
                    }}
                    onRemove={(item) => {
                      if (editedValues) {
                        setEditedValues(
                          editedValues?.filter((i) => item.id !== i.id)
                        );
                      }
                    }}
                    title={label}
                    searchItems={searchItems}
                  />
                )}
              >
                {info}
              </FilterInputButton>
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
